import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bsjumbotron',
	templateUrl:'./BSJumbotronPage.html',
	styles: [],
	styleUrls:['./BSJumbotronPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSJumbotronPage
{
	mdContent_118 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.jumbotron.BSJumbotron;
\`\`\``;
	mdContent_119 = `\`\`\`java
new BSJumbotron<>()
\`\`\``;
	mdContent_120 = `\`\`\`java
var jumbo = new BSJumbotron<>();
jumbo.add(new H1<>().setText("Hello, world!"));
jumbo.add(new Paragraph<>().setText("This is a simple hero unit."));
\`\`\``;
}
